import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import SuccessMessage from './SuccessMessage.js';

const SuccessMessageContainer = ()=>{
    const { getLabel , locale  } = useIntl();
    const messageLabels = React.useMemo(()=>({
            title: getLabel('customersupport.success.title'),
            content: getLabel('customersupport.success.content')
        })
    , [
        locale
    ]);
    return /*#__PURE__*/ React.createElement(SuccessMessage, {
        labels: messageLabels
    });
};

export { SuccessMessageContainer as default };
//# sourceMappingURL=SuccessMessageContainer.js.map
